'use client'

import { toast } from 'sonner'
import React, { useContext, createContext } from 'react'

const ToastContext = createContext()

export const useToast = () => {
  const context = useContext(ToastContext)
  if (!context) {
    throw new Error('useToast must be used within a ToastProvider')
  }
  return context
}

export const ToastProvider = ({ children }) => {
  const showToast = (message, type = 'error', duration = 5000) => {
    switch (type) {
    case 'success':
      toast.success(message, { duration })
      break
    case 'error':
      toast.error(message, { duration })
      break
    case 'warning':
      toast.warning(message, { duration })
      break
    case 'info':
      toast.info(message, { duration })
      break
    default:
      toast(message, { duration })
    }
  }

  return (
    <ToastContext.Provider value={{ showToast }}>
      {children}
    </ToastContext.Provider>
  )
}